import { c as _c } from "react-compiler-runtime";
import React from "react";
import { base } from "./InputContainer.css.js";
import { jsx as _jsx } from "react/jsx-runtime";
const BaseInputContainer = (t0, ref) => {
  const $ = _c(7);
  let children;
  let props;
  if ($[0] !== t0) {
    ({
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = props;
  } else {
    children = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== children || $[4] !== props || $[5] !== ref) {
    t1 = /*#__PURE__*/_jsx("div", {
      className: base,
      ...props,
      ref: ref,
      children: children
    });
    $[3] = children;
    $[4] = props;
    $[5] = ref;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  return t1;
};

/**
 * @deprecated Use `TextField` instead.
 *
 * `TextField` sets up <Label> and <Input> correctly for ARIA.
 */
export const InputContainer = /*#__PURE__*/React.forwardRef(BaseInputContainer);
//# sourceMappingURL=InputContainer.js.map